import { useCallback, useEffect, useRef } from 'react';

export const useCallbackRef = (callback: Function) => {
  const callbackRef = useRef<Function>(callback);
  callbackRef.current = callback;

  return callbackRef;
};

export const useEvent = (callback: Function) => {
  const callbackRef = useCallbackRef(callback);

  return useCallback((...args: any) => {
    const cb = callbackRef.current;
    return cb(...args);
  }, []);
};

export const useInterval = (callback: Function, delay: number) => {
  const callbackRef = useCallbackRef(callback);

  useEffect(() => {
    function tick() {
      callbackRef.current();
    }
    if (delay != null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
